

function DButton(props) {

  return (
    <button className={` h-10 w-32 rounded-full bg-red-600 font-bold text-md text-white hover:bg-transparent hover:border-3 hover:border-red-600 ${props.hoverTextColor=='white'?'hover:text-white':'hover:text-black'} hover:outline hover:outline-2 hover:outline-red-600 transition-all duration-500`} onClick={props.onClick}>
    {props.name}
  </button>
  )
}

export default DButton